import React, { useEffect, useState } from 'react';
import { Outlet, Link } from "react-router-dom";

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://slkilgskchcfcuztcdyx.supabase.co'
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNsa2lsZ3NrY2hjZmN1enRjZHl4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTA0NzU5MDUsImV4cCI6MjAyNjA1MTkwNX0.cmiYpO2Z2AXF9TWgLtApgCe7hpJHNrhTf1Ii7a0RIqQ"
const supabase = createClient(supabaseUrl, supabaseKey)

export default function Portal() {
    const [lessonPlan, setLessonPlan] = useState({
        description: null,
        tasks: null,
        notes: null,
    });
    const [id, setId] = useState(null);
    const [showLink, setShowLink] = useState(false);
    const [newTask, setNewTask] = useState(null);

    const createLink = async () => {
        const newId = Math.random().toString(36).substring(7);
        setId(newId);
        try {
          const { data, error: selectError } = await supabase
            .from('lessons')
            .select()
      
          if (selectError) throw selectError;
          setShowLink(true);
      
          const { error: insertError } = await supabase
            .from('lessons')
            .insert({ 
              id: newId, 
              description: lessonPlan.description,
              tasks: parseTasks(lessonPlan.tasks),
            })
      
          if (insertError) throw insertError;
        } catch (error) {
          console.error('Error:', error.message);
        }
      };

      const parseTasks = (tasks) => {
        return tasks.split(',').map(task => task.trim());
      }

      const addTask = async() => {
        try {
            // Fetch the current tasks
            const { data, error: fetchError } = await supabase
                .from('lessons')
                .select('tasks')
                .eq('id', id)
            
            if (fetchError) throw fetchError;
    
            // Add the new task to the tasks array
            const updatedTasks = [...data[0].tasks, newTask];
    
            // Update the tasks in the database
            const { error: updateError } = await supabase
                .from('lessons')
                .update({ tasks: updatedTasks })
                .eq('id', id)
    
            if (updateError) throw updateError;
        } catch (error) {
            console.error('Error:', error.message);
        }
    }

      return (
        <div className="text-white min-h-screen flex flex-col justify-around items-center">
            <h1 className="text-4xl">Create Portal</h1>
            <div className="flex flex-col justify-around items-center">
                <label>Description</label>
                <input 
                    className="text-black"
                    placeholder="Hangman in Python" 
                    onChange={(e) => setLessonPlan({...lessonPlan, description: e.target.value})}
                />
                <label>Tasks</label>
                <input 
                    className="text-black"
                    placeholder="Create a list of words to guess" 
                    onChange={(e) => setLessonPlan({...lessonPlan, tasks: e.target.value})}
                />
                <button onClick={createLink}>Create Link</button>
                <Link to={`/lesson/${id}`}>{showLink ? "Join Link" : ""}</Link>
                <p>{showLink ? `Your Portal ID: ${id}` : ""}</p>
            </div>
            
            <p>---------------------------------------</p>
            <p className="text-center text-4xl">Existing Portal?</p>
            <div className="flex flex-col justify-center items-center">
                <label>Enter your project ID</label>
                <input className="text-black" onChange={(e) => setId(e.target.value)}></input>
                <label>Enter Task</label>
                <input 
                    className="text-black"
                    onChange={(e) => setNewTask(e.target.value)}
                />
                <button onClick={addTask}>Add Task</button>
            </div>
        </div>
    )
}